import { Box, Container, Heading, SimpleGrid, Text, VStack } from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';
import { testimonials } from '../lib/storage';

const Testimonials: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );
    const section = sectionRef.current;
    if (section) {
      observer.observe(section);
    }

    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  return (
    <Box id="testimonials" ref={sectionRef} bg="white" py={{ base: 16, md: 24 }}>
      <Container maxW="1400px">
        <VStack spacing={12} align="stretch">
          <VStack
            spacing={4}
            textAlign="center"
            opacity={isVisible ? 1 : 0}
            transform={isVisible ? 'translateY(0)' : 'translateY(40px)'}
            transition="all 0.8s ease-out"
          >
            <Text
              fontSize={{ base: 'sm', md: 'md' }}
              fontWeight={700}
              color="stormyTeal"
              letterSpacing="2px"
              textTransform="uppercase"
            >
              Depoimentos reais de clientes
            </Text>
            <Heading
              as="h2"
              fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}
              color="yaleBlue"
              fontWeight={700}
            >
              Histórias de quem contou com a Mendes
            </Heading>
            <Box w="80px" h="4px" bg="stormyTeal" borderRadius="2px" />
          </VStack>

          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={{ base: 6, md: 8 }}>
            {testimonials.map((testimonial, index) => (
              <Box
                key={testimonial.id}
                bg="alabasterGrey"
                p={{ base: 6, md: 8 }}
                borderRadius="8px"
                borderTop="4px solid"
                borderColor="stormyTeal"
                boxShadow="sm"
                opacity={isVisible ? 1 : 0}
                transform={isVisible ? 'translateY(0)' : 'translateY(40px)'}
                transition="all 0.7s ease-out"
                style={{ transitionDelay: `${0.15 + index * 0.08}s` }}
              >
                <VStack align="flex-start" spacing={5}>
                  <Text color="stormyTeal" fontWeight={700} fontSize="sm" textTransform="uppercase">
                    {testimonial.area}
                  </Text>
                  <Text color="graphite" fontSize={{ base: 'md', md: 'lg' }} lineHeight="1.8">
                    “{testimonial.quote}”
                  </Text>
                  <Text color="yaleBlue" fontWeight={700}>
                    {testimonial.author}
                  </Text>
                </VStack>
              </Box>
            ))}
          </SimpleGrid>
        </VStack>
      </Container>
    </Box>
  );
};

export default Testimonials;

